module.exports = __webpack_public_path__ + "static/media/13.273fb524.jpg";